import { render } from "./ObjectListFields.vue?vue&type=template&id=34135ac2&scoped=true"
import script from "./ObjectListFields.vue?vue&type=script&lang=js"
export * from "./ObjectListFields.vue?vue&type=script&lang=js"

import "./ObjectListFields.vue?vue&type=style&index=0&id=34135ac2&lang=scss"
import "./ObjectListFields.vue?vue&type=style&index=1&id=34135ac2&lang=scss&scoped=true"

import exportComponent from "/app/tmp/aft/V3/v2026.4.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34135ac2"]])

export default __exports__